// frontend/src/services/apiService.ts
import api, { CommonResponse } from './api'

// ANCHOR 사용자조회
export const getUser = async () => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getUser')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 회원가입
type SignUpParams = {
  account: string
  password: string
  username: string
  phone: string
  email?: string
  referrer?: string // 추천인 아이디
  signatureData?: string // 전자서명 Base64
}
export const signUp = async (params: SignUpParams) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/signUp', params)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 로그인
type SignInParams = {
  account: string
  password: string
}
export const signIn = async (params: SignInParams) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/signIn', params)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 로그아웃
export const signOut = async () => {
  try {
    const response = await api.delete<CommonResponse>('/api/main/signOut')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 입금 BSC
export const depositBSC = async () => {
  try {
    const response = await api.post<CommonResponse>('/api/main/depositBSC')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 입금 TRC
export const depositTRC = async (params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/depositTRC',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 이용권구매
type BuyPassParams = {
  product: 'BASIC' | 'VIP' | 'SECRET' | 'SECRET+' | 'CEO'
}

export const buyPass = async (params: BuyPassParams) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/buyPass', params)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 키및시크릿업데이트
type UpdateKeyAndSecretParams = {
  key: string
  secret: string
}
export const updateKeyAndSecret = async (params: UpdateKeyAndSecretParams) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/updateKeyAndSecret',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 키및시크릿업데이트[스팟]
type UpdateKeyAndSecretSpotParams = {
  key: string
  secret: string
}
export const updateKeyAndSecretSpot = async (
  params: UpdateKeyAndSecretSpotParams
) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/updateKeyAndSecretSpot',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 트레이딩업데이트
type RoiTrigger = {
  roi: number
  size: number
}

type UpdateTradingParams = {
  symbol?: string
  botStatus: boolean | null
  leverage?: number
  takeProfit?: number
  stopLoss?: number
  size?: number
  direction?: number
  roiTriggers?: RoiTrigger[]
  useStopLoss?: boolean
}

export const updateTrading = async (params: UpdateTradingParams) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/updateTrading',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 포지션 조회
export const getPosition = async () => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getPosition')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 비밀번호 변경
type UpdatePasswordParams = {
  oldPassword: string
  newPassword: string
}
export const updatePassword = async (params: UpdatePasswordParams) => {
  try {
    const response = await api.put<CommonResponse>(
      '/api/main/updatePassword',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 전략리스트조회
export const getStrategyList = async () => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getStrategyList')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 전략적용
type ApplyStrategyParams = {
  id: number // 전략 ID
  seed: number // 투자 시드
  symbols: string[] // ✅ 적용할 심볼 목록
}
export const applyStrategy = async (params: ApplyStrategyParams) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/applyStrategy',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// 심볼 가격 조회
export const getSymbolUsdtPrice = async (symbol: string) => {
  try {
    const response = await api.get<CommonResponse>(
      '/api/main/getSymbolUsdtPrice',
      { params: { symbol } }
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 랭킹리스트조회
export const getRankingList = async () => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getRankingList')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 실시간리스트조회
export const getRealtimeList = async () => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getRealtimeList')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 출금
export const withdrawal = async (params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/withdrawal',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 최근출금내역
export const getRecentWithdrawal = async () => {
  try {
    const response = await api.get<CommonResponse>(
      '/api/main/getRecentWithdrawal'
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 출금취소
export const cancelWithdrawal = async (params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/cancelWithdrawal',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 파트너리스트조회
export const getPartnerList = async () => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getPartnerList')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 사용자리스트조회[관리자기능]
export const getUserList = async (params: any) => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getUserList', {
      params
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR USDT조정[관리자기능]
export const adjustUserUsdt = async (params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/adjustUserUsdt',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 포인트조정[관리자기능]
export const adjustUserPoint = async (params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/adjustUserPoint',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 관리자비밀번호변경[관리자기능]
export const adminChangePassword = async (params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/adminChangePassword',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 관리자사용자명변경[관리자기능]
export const adminChangeUsername = async (params: {
  userId: number
  newUsername: string
}) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/adminChangeUsername',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 이용권구매[관리자기능]
export const purchaseUserPlan = async (params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/purchaseUserPlan',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 회원 추가[관리자기능]
export const createUserByAdmin = async (params: {
  account: string
  password: string
  username: string
  phone: string
}) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/createUserByAdmin',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 입금리스트조회[관리자기능]
export const getDepositList = async (params: any) => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getDepositList', {
      params
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 출금리스트조회[관리자기능]
export const getWithdrawalList = async (params: any) => {
  try {
    const response = await api.get<CommonResponse>(
      '/api/main/getWithdrawalList',
      {
        params
      }
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 매출리스트조회[관리자기능]
export const getSalesList = async (params: any) => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getSalesList', {
      params
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 트론입금승인[관리자기능]
export const approveTRC = async (params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/approveTRC',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 출금취소[관리자기능]
export const cancelWithdrawalAdmin = async (params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/cancelWithdrawalAdmin',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 출금승인[관리자기능]
export const approveWithdrawalAdmin = async (params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/approveWithdrawalAdmin',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 현물업데이트
export const updateTradingSpot = async (params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/updateTradingSpot',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 현물업데이트
export const increaseService = async (params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/increaseService',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 이용권날짜조정[관리자기능]
export const setUserServiceDate = async (params: {
  userId: number
  dateType: 'serviceAt' | 'referralAt' | 'subscriptionAt'
  newDate: string
}) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/setUserServiceDate',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR API키설정[관리자기능]
export const adminSetApiKey = async (params: {
  userId: number
  apiKey: string
  apiSecret: string
}) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/adminSetApiKey',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR API키조회[관리자기능]
export const adminGetApiKey = async (userId: number) => {
  try {
    const response = await api.get<CommonResponse>(
      '/api/main/adminGetApiKey',
      { params: { userId } }
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 관리자권한설정[관리자기능]
export const adminSetIsAdmin = async (params: {
  targetUserId: number
  isAdmin: number
}) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/adminSetIsAdmin',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 코인가격조회 (KRW 마켓, Query 방식)
export const getCoinKrwPrice = async (symbol: string) => {
  try {
    const response = await api.get<CommonResponse>(
      '/api/main/getCoinKrwPrice',
      {
        params: { symbol } // 예: BTC, ETH, SOL, DOGE, XRP
      }
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 봇상태조회[관리자기능]
export const getBotStatus = async (params: any) => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getBotStatus', {
      params
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 게시글 목록 조회
export const getCommunityPosts = async (params: {
  page?: number
  pageSize?: number
  category?: 'FREE' | 'PROFIT'
}) => {
  try {
    const response = await api.get<CommonResponse>(
      '/api/main/getCommunityPosts',
      { params }
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 게시글 상세 조회
export const getCommunityPost = async (id: number) => {
  try {
    const response = await api.get<CommonResponse>(
      `/api/main/getCommunityPost/${id}`
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 게시글 작성
export const createCommunityPost = async (params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/createCommunityPost',
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 게시글 수정
export const updateCommunityPost = async (id: number, params: any) => {
  try {
    const response = await api.put<CommonResponse>(
      `/api/main/updateCommunityPost/${id}`,
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 게시글 삭제
export const deleteCommunityPost = async (id: number) => {
  try {
    const response = await api.delete<CommonResponse>(
      `/api/main/deleteCommunityPost/${id}`
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 댓글 목록 조회
export const getCommunityComments = async (postId: number) => {
  try {
    const response = await api.get<CommonResponse>(
      `/api/main/getCommunityComments/${postId}`
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 댓글 작성
export const createCommunityComment = async (postId: number, params: any) => {
  try {
    const response = await api.post<CommonResponse>(
      `/api/main/createCommunityComment/${postId}`,
      params
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 댓글 삭제
export const deleteCommunityComment = async (id: number) => {
  try {
    const response = await api.delete<CommonResponse>(
      `/api/main/deleteCommunityComment/${id}`
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 게시글 좋아요
export const likeCommunityPost = async (postId: number) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/likeCommunityPost',
      { postId }
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 게시글 싫어요
export const dislikeCommunityPost = async (postId: number) => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/dislikeCommunityPost',
      { postId }
    )
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 사용자의 게시글 좋아요/싫어요 상태 확인
export const getUserPostLikeStatus = async (postId: number): Promise<{ isLiked: boolean; isDisliked: boolean }> => {
  try {
    const response = await api.get<CommonResponse>(
      `/api/main/getUserPostLikeStatus/${postId}`
    )
    return response.data.data
  } catch (error) {
    console.error('Error: ', error)
    return { isLiked: false, isDisliked: false }
  }
}

// ANCHOR 사용자의 댓글 좋아요/싫어요 상태 확인
export const getUserCommentLikeStatus = async (commentId: number): Promise<{ isLiked: boolean; isDisliked: boolean }> => {
  try {
    const response = await api.get<CommonResponse>(
      `/api/main/getUserCommentLikeStatus/${commentId}`
    )
    return response.data.data
  } catch (error) {
    console.error('Error: ', error)
    return { isLiked: false, isDisliked: false }
  }
}

// ANCHOR 커뮤니티 댓글 좋아요
export const likeCommunityComment = async (commentId: number): Promise<CommonResponse> => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/likeCommunityComment',
      { commentId }
    )
    return response.data
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 커뮤니티 댓글 싫어요
export const dislikeCommunityComment = async (commentId: number): Promise<CommonResponse> => {
  try {
    const response = await api.post<CommonResponse>(
      '/api/main/dislikeCommunityComment',
      { commentId }
    )
    return response.data
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 이미지 업로드 (Cloudflare Images)
export const uploadImage = async (file: File): Promise<CommonResponse> => {
  try {
    const formData = new FormData()
    formData.append('image', file)

    const response = await api.post<CommonResponse>(
      '/api/main/uploadImage',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 닉네임 설정
export const setNickname = async (nickname: string): Promise<CommonResponse> => {
  try {
    const response = await api.post<CommonResponse>('/api/main/setNickname', {
      nickname
    })
    return response.data
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 사용자 이력 조회[관리자기능]
export const getUserHistoryList = async (params: {
  userId: number
  page?: number
  pageSize?: number
}) => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getUserHistoryList', {
      params
    })
    return response.data
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR BASIC 이용권 구매
export const purchaseBasicPass = async (params: {
  purchaseType: 'self' | 'other'
  targetUsername?: string
}) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/purchaseBasicPass', params)
    return response.data
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 포인트샵 재고 조회
export const getPointShopStock = async () => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getPointShopStock')
    return response.data
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 대시보드 통계 조회
export const getDashboardStats = async () => {
  try {
    const response = await api.get<CommonResponse>('/api/main/getDashboardStats')
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 산하 매출 조회[관리자기능]
export const getSubordinateSales = async (account: string) => {
  try {
    const response = await api.get<CommonResponse>(`/api/main/getSubordinateSales?account=${encodeURIComponent(account)}`)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 포인트 선물
export const giftPoint = async (params: {
  targetUsername: string
  pointAmount: number
}) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/giftPoint', params)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 사용자 Gate.io 포지션 조회[관리자기능]
export const adminGetPosition = async (userId: number, symbol?: string) => {
  try {
    const response = await api.get<CommonResponse>('/api/main/adminGetPosition', {
      params: { userId, symbol }
    })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 사용자 Gate.io 포지션 청산[관리자기능]
export const adminClosePosition = async (params: {
  userId: number
  symbol: string
  side: 'long' | 'short' | 'all'
  size?: number
}) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/adminClosePosition', params)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 전체 유저 Gate.io 포지션 청산[관리자기능]
export const adminCloseAllPositions = async (side: 'long' | 'short' | 'all' = 'all') => {
  try {
    const response = await api.post<CommonResponse>('/api/main/adminCloseAllPositions', { side })
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 사용자 Gate.io 마진 모드 변경[관리자기능]
export const adminSwitchMarginMode = async (params: {
  userId: number
  symbol: string
  mode: 'CROSS' | 'ISOLATED'
}) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/adminSwitchMarginMode', params)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 사용자 Gate.io 물타기 횟수 초기화[관리자기능]
export const adminResetDCA = async (params: {
  userId: number
  symbol: string
  side: 'long' | 'short' | 'all'
}) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/adminResetDCA', params)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}

// ANCHOR 전체 유저 봇 상태 변경[관리자기능]
export const adminToggleAllBotStatus = async (params: {
  symbol: string
  botStatus: boolean
}) => {
  try {
    const response = await api.post<CommonResponse>('/api/main/adminToggleAllBotStatus', params)
    return response
  } catch (error) {
    console.error('Error: ', error)
    throw error
  }
}
